import { memo, ReactElement } from 'react';
import Row from './Row';
import { useIsActive } from '../hooks/useIsActive';

const Rows = memo(function Rows(): ReactElement {
  const { users, updateIsActive } = useIsActive();

  return (
    <>
      {users.map(user => (
        <Row
          key={user.id}
          id={user.id}
          name={user.name}
          email={user.email}
          isActive={user.isActive}
          updateIsActive={updateIsActive}
        />
      ))}
    </>
  );
});

export default Rows;
